import { validateScene } from '../validation/index.js';
import { mapMutations } from 'vuex'

export const saveScene = {
  methods: {
    ...mapMutations(['selectScene', 'setMode', 'resetSelection']),
    saveScene() {
      console.log("onSaveScene: validateScene: ", validateScene)
      // there are corner cases where after a reload there is no tag selected,
      // ommit the check in this case
      if (this.selection && this.selection.tag) {
        let check = validateScene(this.selection.tag, this.selection.scene)
        if (!check.valid) {
          console.log("saveScene", this.selection.tag, this.selection.scene)
          const options = {title: "Errors", cancelLabel: null}
          this.$dialogs.confirm(check.msg, options).then(res => {
            return false
          })
          return false
        }
      }
      this.selectScene(null)
      this.setMode('playing')
      this.resetSelection()
    }
  }
}